// Gestore dei dati del visitatore
// Session data: dati della sessione attiva, traccia le pagine visitate e la data di inizio della sessione
// Client data: dati persistenti del visitatore, traccia prodotti visitati e l'ultima volta che ha visitato il sito
// Il session data traccia anche la data di inizio della sessione precedente (recuperata dal client data all'avvio)

import type { PageVisitInfo, ProductPageVisitInfo, RouteInfo } from './router/MainRouter';
import { storage } from './storage';

// Session data

type SessionDataStored = {
  history: Array<PageVisitInfo>;
  // previousSessionStartDate è la data di inizio della sessione precedente, viene recuperata dal client data e salvata nel session storage
  previousSessionStartDate?: string;
  sessionStartDate: string;
};

const SESSION_DATA_KEY = 'sessionData';
const MAX_HISTORY_ITEMS = 10;

export const getSessionData = () =>
  storage.getObject<SessionDataStored>(SESSION_DATA_KEY, false, true) || {
    history: [],
    sessionStartDate: new Date().toISOString(),
  };

// Client data
type ClientDataStored = {
  // Data di inizio dell'ultima sessione del cliente
  lastSessionStartDate?: string;
  productsHistory: Array<ProductPageVisitInfo>;
};

const CLIENT_DATA_KEY = 'clientData';
const MAX_PRODUCTS_HISTORY_ITEMS = 10;

export const getClientData = () =>
  storage.getObject<ClientDataStored>(CLIENT_DATA_KEY, true, true) || {
    lastSessionStartDate: undefined,
    productsHistory: [],
  };

// Traccia la visita di una pagina e gestisce l'aggiornamento delle date di sessione
// Gestisce automaticamente la creazione del sessionStartDate, non esiste nessun metodo esplicito per settarlo.
export const trackPageVisit = (path: string, routeInfo?: RouteInfo) => {
  const sessionData = getSessionData();
  const clientData = getClientData();
  const visitedAt = new Date().toISOString();

  // Se non c'è la data di inizio della sessione precedente vuol dire che questa è la prima visita del cliente (inizio della sessione)
  // La imposto con la data di inizio della sessione precedente e aggiorno quella attuale nel client data
  if (!sessionData.previousSessionStartDate) {
    sessionData.previousSessionStartDate = clientData.lastSessionStartDate;
    clientData.lastSessionStartDate = sessionData.sessionStartDate;
    storage.setObject(CLIENT_DATA_KEY, clientData, true, true);
  }

  sessionData.history.push({
    path: path,
    type: routeInfo?.type,
    visitedAt: visitedAt,
  });
  if (sessionData.history.length > MAX_HISTORY_ITEMS) {
    sessionData.history.shift();
  }
  storage.setObject(SESSION_DATA_KEY, sessionData, false, true);

  if (routeInfo?.type === 'product') {
    clientData.productsHistory.push({
      path: routeInfo.pathParam,
      visitedAt: visitedAt,
    });
    if (clientData.productsHistory.length > MAX_PRODUCTS_HISTORY_ITEMS) {
      clientData.productsHistory.shift();
    }
    storage.setObject(CLIENT_DATA_KEY, clientData, true, true);
  }
};
